/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LogEventEntity,
    LogEventEntityFromJSON,
    LogEventEntityFromJSONTyped,
    LogEventEntityToJSON,
} from './LogEventEntity';
import {
    Pageable,
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import {
    Sort,
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface PageLogEventEntity
 */
export interface PageLogEventEntity {
    /**
     * 
     * @type {number}
     * @memberof PageLogEventEntity
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLogEventEntity
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLogEventEntity
     */
    size?: number;
    /**
     * 
     * @type {Array<LogEventEntity>}
     * @memberof PageLogEventEntity
     */
    content?: Array<LogEventEntity>;
    /**
     * 
     * @type {number}
     * @memberof PageLogEventEntity
     */
    number?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageLogEventEntity
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageLogEventEntity
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof PageLogEventEntity
     */
    pageable?: Pageable;
    /**
     * 
     * @type {boolean}
     * @memberof PageLogEventEntity
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLogEventEntity
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLogEventEntity
     */
    empty?: boolean;
}

export function PageLogEventEntityFromJSON(json: any): PageLogEventEntity {
    return PageLogEventEntityFromJSONTyped(json, false);
}

export function PageLogEventEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageLogEventEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(LogEventEntityFromJSON)),
        'number': !exists(json, 'number') ? undefined : json['number'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'empty': !exists(json, 'empty') ? undefined : json['empty'],
    };
}

export function PageLogEventEntityToJSON(value?: PageLogEventEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPages': value.totalPages,
        'totalElements': value.totalElements,
        'size': value.size,
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(LogEventEntityToJSON)),
        'number': value.number,
        'sort': SortToJSON(value.sort),
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'first': value.first,
        'last': value.last,
        'empty': value.empty,
    };
}

